<template>
  <div>
    <v-card flat class="mb-7">
      <v-card-title>Conclusão</v-card-title>

      <v-card-text>
        <p class="mb-6">
          Confirme uma última vez as informações a enviar à sua seguradora.
        </p>

        <!-- SEGURADO (SEM CORREÇÃO) -->
        <v-row v-if="insured?.name">
          <v-col>
            <div class="section">Segurado</div>

            <v-card flat color="#f1f1f1">
              <v-simple-table class="pa-3" style="background: transparent">
                <tbody>
                  <tr>
                    <th width="150">Nome</th>
                    <td>{{ insured.name }}</td>
                  </tr>

                  <tr>
                    <th>Email</th>
                    <td>{{ insured.email || "—" }}</td>
                  </tr>

                  <tr>
                    <th>Contactos</th>
                    <td>
                      {{
                        [insured.contact1, insured.contact2]
                          .filter(Boolean)
                          .join(", ") || "—"
                      }}
                    </td>
                  </tr>

                  <tr v-if="insuredAddress">
                    <th>Morada</th>
                    <td>{{ formatAddress(insuredAddress) }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>

        <!-- TERCEIROS -->
        <v-row v-if="thirdParties.length">
          <v-col>
            <div class="section d-flex align-center">
              Terceiros
              <v-btn
                small
                outlined
                class="ml-2"
                :color="insurer.color"
                @click="$emit('edit', { horizontalStep: '3', verticalStep: 4 })"
              >
                <v-icon left>mdi-pencil</v-icon>
                Corrigir
              </v-btn>
            </div>

            <v-row dense>
              <v-col
                v-for="third in thirdParties"
                :key="third.id"
                cols="12"
                sm="6"
                md="4"
              >
                <v-card flat color="#f1f1f1">
                  <v-card-text>
                    <strong>{{ third.name || "—" }}</strong>

                    <div class="text-caption grey--text mt-1">
                      {{ third.contact?.email || "—" }}
                    </div>

                    <div class="text-caption grey--text">
                      {{
                        [third.contact?.contact1, third.contact?.contact2]
                          .filter(Boolean)
                          .join(", ")
                      }}
                    </div>

                    <div class="text-caption grey--text mt-1">
                      {{ formatAddress(third.contact?.address) }}
                    </div>

                    <div class="text-caption grey--text mt-1">
                      {{ typologyLabel(third.risk_location_typology) }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- PARTICIPAÇÃO -->
        <v-row>
          <v-col>
            <div class="section d-flex align-center">
              Participação
              <v-btn
                small
                outlined
                class="ml-2"
                :color="insurer.color"
                @click="$emit('edit', { horizontalStep: '2' })"
              >
                <v-icon left>mdi-pencil</v-icon>
                Corrigir
              </v-btn>
            </div>

            <v-card flat color="#f1f1f1" class="mb-2">
              <v-card-text>
                <strong>Descrição:</strong>
                {{ participation || "—" }}
              </v-card-text>
            </v-card>

            <v-card flat color="#f1f1f1">
              <v-card-text>
                <strong>Data da ocorrência:</strong>
                {{ date ? formatDate(date) : "—" }}
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <!-- DANOS -->
        <v-row v-if="damages.length">
          <v-col>
            <div class="section d-flex align-center">
              Danos
              <v-btn
                small
                outlined
                class="ml-2"
                :color="insurer.color"
                @click="$emit('edit', { horizontalStep: '3', verticalStep: 2 })"
              >
                <v-icon left>mdi-pencil</v-icon>
                Corrigir
              </v-btn>
            </div>

            <v-row dense>
              <v-col
                v-for="damage in damages"
                :key="damage.id"
                cols="12"
                sm="6"
                md="4"
              >
                <v-card flat color="#f1f1f1" class="h-100">
                  <v-img
                    v-if="damage.path"
                    :src="damage.path"
                    height="160"
                    contain
                    class="grey lighten-4"
                  />

                  <v-card-text class="text-caption">
                    {{ damage.description || "—" }}
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!-- DOCUMENTOS -->
        <v-row v-if="documents.length">
          <v-col>
            <div class="section d-flex align-center">
              Documentos
              <v-btn
                small
                outlined
                class="ml-2"
                :color="insurer.color"
                @click="$emit('edit', { horizontalStep: '3', verticalStep: 3 })"
              >
                <v-icon left>mdi-pencil</v-icon>
                Corrigir
              </v-btn>
            </div>

            <v-row dense>
              <v-col
                v-for="doc in documents"
                :key="doc.id"
                cols="12"
                sm="6"
                md="4"
              >
                <v-card flat color="#f1f1f1">
                  <v-card-text>
                    <strong>{{ documentLabel(doc.type) }}</strong>
                    <div class="text-caption grey--text mt-1">
                      {{ doc.fileName }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- CONFIRMAR -->
      <v-card-actions>
        <v-spacer />
        <v-btn :color="insurer.color" dark @click="confirm"> Confirmar </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { formatDate } from "@/tools/date";

export default {
  name: "ConclusionDNA",

  props: {
    insurer: Object,
  },

  data() {
    return {
      insured: {},
      insuredAddress: null,

      thirdParties: [],
      participation: "",
      date: "",
      documents: [],
      damages: [],

      formatDate,
    };
  },

  methods: {
    refresh() {
      const insuredRaw = localStorage.getItem("insured");
      if (insuredRaw) {
        this.insured = JSON.parse(insuredRaw);
        this.insuredAddress = this.insured.contracts?.[0]?.address || null;
      }

      const participants = JSON.parse(
        localStorage.getItem("participants") || "[]"
      );

      this.thirdParties = participants.filter(
        (p) => p.participant_type?.canonical === "third_party"
      );

      this.participation = localStorage.getItem("participation") || "";
      this.date = localStorage.getItem("date") || "";

      this.documents = JSON.parse(
        localStorage.getItem("dna_documents") || "[]"
      );

      this.damages = JSON.parse(
        localStorage.getItem("risk_location_damages") || "[]"
      );
    },

    confirm() {
      this.$emit("continue", {
        flow: "DNA",
        participation: this.participation,
        insured: this.insured,
        date: this.date,
        documents: this.documents,
        damages: this.damages,
      });
    },

    formatAddress(address) {
      if (!address) return "—";

      return [
        address.street,
        `nº ${address.number}`,
        address.local,
        address.postal_code,
        address.city?.name,
        address.country_area?.name,
      ]
        .filter(Boolean)
        .join(", ");
    },

    typologyLabel(value) {
      return (
        {
          house: "Moradia",
          apartment: "Apartamento",
          garage: "Garagem",
          office: "Escritório",
          commercial_room: "Espaço comercial",
          warehouse: "Armazém",
          land: "Terreno",
          building: "Prédio",
        }[value] || "—"
      );
    },

    documentLabel(type) {
      return (
        {
          property_booklet: "Caderneta predial",
          invoice: "Faturas",
          budget: "Orçamentos",
          report: "Relatórios técnicos",
          iban: "Comprovativo bancário (IBAN)",
        }[type] || "Documento"
      );
    },
  },

  created() {
    this.refresh();
  },
};
</script>

<style scoped>
.section {
  font-size: 1rem;
  font-weight: 500;
  margin: 1.5rem 0 0.75rem;
}
</style>
